__turbopack_context__.v({
  "dialog": "PlaygroundDialog-module__mY0knq__dialog",
  "dialogBodyText": "PlaygroundDialog-module__mY0knq__dialogBodyText",
  "dialogButtonContainer": "PlaygroundDialog-module__mY0knq__dialogButtonContainer",
  "dialogPanel": "PlaygroundDialog-module__mY0knq__dialogPanel",
  "dialogPanelCentered": "PlaygroundDialog-module__mY0knq__dialogPanelCentered",
  "dialogPanelContainer": "PlaygroundDialog-module__mY0knq__dialogPanelContainer",
  "dialogTitle": "PlaygroundDialog-module__mY0knq__dialogTitle",
  "header": "PlaygroundDialog-module__mY0knq__header",
  "main": "PlaygroundDialog-module__mY0knq__main",
  "overlay": "PlaygroundDialog-module__mY0knq__overlay",
});
